/**
 * This is an adapter over the legacy router 
 * 
 * To make this Page usable by the router we must use the jQuery
 * extended class Page defined in public/js/lib/treme.pages.js
 * 
 * @created: 18-01-2021
 * @author: Mario Zito <mario.zito@treme.io>
 */
export function route(options) {
  let page = jQuery(options.page).Page(options.route);
  return page;
}
